import React, {useEffect, useState} from "react";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider,
    Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, useTheme
} from "@material-ui/core";
import {inspectionService} from "../../services/InspectionService";
import type Comment from "../../services/dto/Comment";
import {FaTrash} from "react-icons/fa";
import {CommentForm} from "./CommentForm";
import {IoMdClose} from "react-icons/io";

export interface CommentDialogProps {
    inspectionId: number,
    open: boolean,
    handleClose: () => void,
    didUpdateComments: (comments: Comment[]) => void,
}
export const CommentDialog : React.FC<CommentDialogProps> = ({inspectionId ,open, handleClose, didUpdateComments}) =>  {

    const theme= useTheme();

    const [comments : Comment[], setComments] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedComment : Comment, setSelectedComment] = useState(null);

    useEffect(() => {
        setLoading(false);
        if(open) {
            setLoading(true);
            inspectionService.loadComments(inspectionId).then((data) => {
                console.log(data);
                setComments(data);
                setLoading(false);
            })
        }
    }, [open, inspectionId]);

    useEffect(() => {
        if(didUpdateComments) {
            didUpdateComments(comments);
        }
    }, [comments]);

    return (
        <Dialog fullScreen open={open} onClose={handleClose}>
            <DialogTitle>Hinweise zur Prüfung</DialogTitle>
            <IconButton style={{position: 'absolute', right: '5px', top:'5px'}} onClick={handleClose}><IoMdClose size={30} /></IconButton>
            <DialogContent>
                {loading && (
                    <Grid container spacing={2} style={{height:'100%'}}>
                        <Grid item xs={12}>
                            <CircularProgress variant={"indeterminate"} color="primary" size={30} />
                        </Grid>
                    </Grid>
                )}
                {!loading && comments.length > 0 && (
                    <List>
                        {comments.map((comment, index) => {

                            return (
                                <>
                                    <ListItem style={{border: '1px solid', borderColor: theme.palette.primary.main, marginBottom: '5px',
                                        borderRadius: '4px', backgroundColor: theme.palette.primary.light }} button onClick={() => {
                                        setSelectedComment(comment)
                                    }}>
                                        <ListItemText primary={comment.key} secondary={comment.content}></ListItemText>
                                        {/*<ListItemSecondaryAction>*/}
                                        {/*    /!*<IconButton>*!/*/}
                                        {/*    /!*    <MdEdit />*!/*/}
                                        {/*    /!*</IconButton>*!/*/}
                                        {/*    <IconButton color={'secondary'}>*/}
                                        {/*        <FaTrash onClick={() => {*/}
                                        {/*            const result = window.confirm(`Soll der Eintrag mit der Referenz '${comment.key}' gelöscht werden?`);*/}
                                        {/*            alert(result);*/}
                                        {/*        }} />*/}
                                        {/*    </IconButton>*/}
                                        {/*</ListItemSecondaryAction>*/}
                                    </ListItem>
                                </>

                            )
                        })}
                    </List>
                )}
                {!loading && comments.length == 0 && (
                    <div style={{backgroundColor: 'transparent', fontSize: '24px', height: '100%', display: 'flex', placeContent: 'center', placeItems: 'center', textAlign: 'center'}}>
                        <label>Für diese Prüfung wurden noch <b>keine Hinweise</b> erstellt...</label>
                    </div>

                )}
            </DialogContent>
            <CommentForm open={!!selectedComment} handleClose={() => {
                setSelectedComment(undefined)
            }} comment={selectedComment} inspectionId={inspectionId} onDidSaveComment={(comments: Comment[]) => {
                setComments(comments)
            }}></CommentForm>
            <DialogActions>
                <Button fullWidth size={'large'} variant={'contained'} color={'primary'} onClick={() => {
                    setSelectedComment(new Comment())
                }}>Hinweis erstellen</Button>
            </DialogActions>
        </Dialog>
    )
}